import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt eine Anzeigeart zurück.
 */
export function getDisplayType(id: number): JQueryPromise<modelsGet.IDisplayType>
{
    var endpoint = new URI("api/display-types");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IDisplayType>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Anzeigearten zurück.
 */
export function getDisplayTypes(): JQueryPromise<modelsGet.IDisplayType[]>
{
    var endpoint = new URI("api/display-types");

    return api.get<modelsGet.IDisplayType[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(displayType: modelsPost.IDisplayType): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/display-types/create",
        data: JSON.stringify(displayType)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, displayType: modelsPost.IDisplayType): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/display-types/edit/${id}`,
        data: JSON.stringify(displayType)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/display-types/delete/${id}`
    });
}